import Icon from '@/components/ui/AppIcon';

interface ComparisonFeature {
  label: string;
  static: boolean;
  living: boolean;
}

const ComparisonSection = () => {
  const features: ComparisonFeature[] = [
    { label: 'Pravidelné aktualizace', static: false, living: true },
    { label: 'Reakce na životní změny', static: false, living: true },
    { label: 'Průběžná optimalizace', static: false, living: true },
    { label: 'Osobní konzultace', static: false, living: true },
    { label: 'Monitoring pokroku', static: false, living: true },
    { label: 'Flexibilní úpravy cílů', static: false, living: true },
    { label: 'Dlouhodobé partnerství', static: false, living: true },
    { label: 'Jednorázové vypracování', static: true, living: false },
  ];

  return (
    <section className="py-16 lg:py-24 bg-surface">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4 font-headline">
              Statický dokument vs. Živý plán
            </h2>
            <p className="text-lg text-text-secondary max-w-2xl mx-auto">
              Rozdíl mezi tradičním finančním plánem a naším přístupem živého dokumentu
            </p>
          </div>

          <div className="bg-card rounded-xl shadow-elevated overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-3 divide-y lg:divide-y-0 lg:divide-x divide-border">
              {/* Feature Column */}
              <div className="p-6 lg:p-8">
                <div className="h-16 flex items-center mb-4">
                  <h3 className="text-lg font-semibold text-text-primary">Vlastnosti</h3>
                </div>
                <div className="space-y-4">
                  {features.map((feature, index) => (
                    <div key={index} className="h-12 flex items-center">
                      <span className="text-sm text-text-secondary">{feature.label}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Static Plan Column */}
              <div className="p-6 lg:p-8 bg-muted/30">
                <div className="h-16 flex flex-col justify-center mb-4">
                  <div className="flex items-center space-x-2 mb-1">
                    <Icon name="DocumentIcon" size={24} className="text-text-secondary" />
                    <h3 className="text-lg font-semibold text-text-primary">Statický plán</h3>
                  </div>
                  <p className="text-xs text-text-secondary">Tradiční přístup</p>
                </div>
                <div className="space-y-4">
                  {features.map((feature, index) => (
                    <div key={index} className="h-12 flex items-center justify-center">
                      {feature.static ? (
                        <div className="w-8 h-8 rounded-full bg-success/20 flex items-center justify-center">
                          <Icon name="CheckIcon" size={20} className="text-success" />
                        </div>
                      ) : (
                        <div className="w-8 h-8 rounded-full bg-error/20 flex items-center justify-center">
                          <Icon name="XMarkIcon" size={20} className="text-error" />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Living Plan Column */}
              <div className="p-6 lg:p-8 bg-primary/5">
                <div className="h-16 flex flex-col justify-center mb-4">
                  <div className="flex items-center space-x-2 mb-1">
                    <Icon name="SparklesIcon" size={24} className="text-primary" />
                    <h3 className="text-lg font-semibold text-primary">Živý plán</h3>
                  </div>
                  <p className="text-xs text-text-secondary">Náš přístup</p>
                </div>
                <div className="space-y-4">
                  {features.map((feature, index) => (
                    <div key={index} className="h-12 flex items-center justify-center">
                      {feature.living ? (
                        <div className="w-8 h-8 rounded-full bg-success/20 flex items-center justify-center">
                          <Icon name="CheckIcon" size={20} className="text-success" />
                        </div>
                      ) : (
                        <div className="w-8 h-8 rounded-full bg-error/20 flex items-center justify-center">
                          <Icon name="XMarkIcon" size={20} className="text-error" />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 p-6 bg-trust rounded-lg border border-primary/20">
            <div className="flex items-start space-x-3">
              <Icon name="InformationCircleIcon" size={24} className="text-primary flex-shrink-0 mt-0.5" />
              <div>
                <h4 className="font-semibold text-trust-foreground mb-2">Proč živý dokument?</h4>
                <p className="text-sm text-trust-foreground/80 leading-relaxed">
                  Život se neustále mění – nová práce, rodina, bydlení, neočekávané události. Váš finanční plán musí tyto změny reflektovat v reálném čase, ne až když je pozdě. Proto s vámi zůstáváme v kontaktu a pravidelně aktualizujeme strategii podle vašich aktuálních potřeb.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;